/// <amd-module name="Feed/Legacy/DataServices/SettingsDataService" />
import { IVssRestClientOptions, Services, VssService, IVssService } from "VSS/Platform/Context";
import { ISettingsRestClient } from "VSS/Platform/RestClient/Settings";

import { FeedServiceInstanceId, SettingsConstants } from "Feed/Common/Constants/Constants";

export interface IFeedSettingsDataService extends IVssService {
    // tslint:disable-next-line:no-any
    getPackageSettingsAsync(): Promise<{ [key: string]: any }>;

    setMruFullyQualifiedFeedId(feedId: string): Promise<void>;
}

export class SettingsDataService extends VssService implements IFeedSettingsDataService {
    private settingsClient: ISettingsRestClient;
    public setMruFullyQualifiedFeedId(feedId: string): Promise<void> {
        // tslint:disable-next-line:no-any
        const entries: { [key: string]: any } = {};
        entries[SettingsConstants.MruFeedIdPath] = feedId;

        return this.SettingsRestClient.setEntries(entries, "me");
    }

    // tslint:disable-next-line:no-any
    public async getPackageSettingsAsync(): Promise<{ [key: string]: any }> {
        const packageSettingEntries = await this.SettingsRestClient.getEntries(
            "me",
            SettingsConstants.PackagingSettingsPath
        );
        return packageSettingEntries;
    }

    private get SettingsRestClient(): ISettingsRestClient {
        if (this.settingsClient == null) {
            this.settingsClient = this.pageContext.getRestClient<ISettingsRestClient>("ISettingsRestClient", {
                serviceInstanceType: FeedServiceInstanceId
            } as IVssRestClientOptions);
        }
        return this.settingsClient;
    }
}

Services.add("IFeedSettingsDataService", { serviceFactory: SettingsDataService });
